import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import store from "./store";
import "./index.css";

import {
    LanguageProvider
} from "./contexts/LanguageContext";

ReactDOM.render(
    <Provider store={store}>
        <LanguageProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </LanguageProvider>
    </Provider>,
    document.getElementById("root")
);